/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { V1WorkoutRequestData } from './V1WorkoutRequestData'
import {
    V1WorkoutRequestDataFromJSON,
    V1WorkoutRequestDataFromJSONTyped,
    V1WorkoutRequestDataToJSON,
    V1WorkoutRequestDataToJSONTyped
} from './V1WorkoutRequestData'

/**
 *
 * @export
 * @interface V1CreateRequestPayload
 */
export interface V1CreateRequestPayload {
    /**
     *
     */
    coachId: string
    /**
     *
     */
    description: string
    /**
     *
     */
    amount: number
    /**
     *
     */
    data?: V1WorkoutRequestData
}

/**
 * Check if a given object implements the V1CreateRequestPayload interface.
 */
export function instanceOfV1CreateRequestPayload(
    value: object
): value is V1CreateRequestPayload {
    if (!('coachId' in value) || value['coachId'] === undefined) return false
    if (!('description' in value) || value['description'] === undefined)
        return false
    if (!('amount' in value) || value['amount'] === undefined) return false
    return true
}

export function V1CreateRequestPayloadFromJSON(
    json: any
): V1CreateRequestPayload {
    return V1CreateRequestPayloadFromJSONTyped(json, false)
}

export function V1CreateRequestPayloadFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): V1CreateRequestPayload {
    if (json == null) {
        return json
    }
    return {
        coachId: json['coachId'],
        description: json['description'],
        amount: json['amount'],
        data:
            json['data'] == null
                ? undefined
                : V1WorkoutRequestDataFromJSON(json['data'])
    }
}

export function V1CreateRequestPayloadToJSON(
    json: any
): V1CreateRequestPayload {
    return V1CreateRequestPayloadToJSONTyped(json, false)
}

export function V1CreateRequestPayloadToJSONTyped(
    value?: V1CreateRequestPayload | null,
    ignoreDiscriminator: boolean = false
): any {
    if (value == null) {
        return value
    }

    return {
        coachId: value['coachId'],
        description: value['description'],
        amount: value['amount'],
        data: V1WorkoutRequestDataToJSON(value['data'])
    }
}
